export const enhanceGoogleImageResolution = (googleUrl: string): string => {
    try {
      // Common patterns for Google avatar URLs
      const patterns = [
        // Pattern: /s96-c/ -> replace with /s512-c/
        { regex: /\/s(\d+)-c\//g, replacement: '/s512-c/' },
        // Pattern: /s96/ -> replace with /s512/
        { regex: /\/s(\d+)\//g, replacement: '/s512/' },
        // Pattern: =s96-c -> replace with =s512-c
        { regex: /=s(\d+)-c/g, replacement: '=s512-c' },
        // Pattern: =s96 -> replace with =s512
        { regex: /=s(\d+)/g, replacement: '=s512' },
      ];
  
      let enhancedUrl = googleUrl;
      
      // Apply all pattern replacements
      patterns.forEach(pattern => {
        enhancedUrl = enhancedUrl.replace(pattern.regex, pattern.replacement);
      });
  
      // If no replacement occurred, try adding size parameter
      if (enhancedUrl === googleUrl) {
        const urlObj = new URL(googleUrl);
        if (!urlObj.searchParams.has('sz') && !urlObj.searchParams.has('s')) {
          // Check if it looks like a circular avatar
          const isCircular = googleUrl.includes('-c') || urlObj.pathname.includes('-c');
          urlObj.searchParams.set('sz', isCircular ? '512-c' : '512');
          enhancedUrl = urlObj.toString();
        }
      }
  
      return enhancedUrl;
    } catch (error) {
      console.warn('Failed to enhance Google image URL:', error);
      return googleUrl;
    }
  };